import { http, HttpResponse } from 'msw'

import { api } from '@/utils/constants'

import { SalesStats } from '@/types/dashboard/salesStats'

export const getStats = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.DASHBOARD}`,
    () => {
        return HttpResponse.json<SalesStats>({
            sales_count: 222,
            sales_amount: 111,
            products_amount: 333,
        })
    },
)
